import React, { useState } from 'react';
import InstallmentItem from './InstallmenttItem';

export default function Installments({ selected, changeHandler, options }) {

    if (!options?.length) return null;

    function handleInstallmentClick(option) {
        changeHandler(option);
    }

    return (
        <>
            <h3>¿En cuántas cuotas lo querés pagar?</h3>

            <div className="installments">
                {options.map(((eachInstallment) => (
                    <InstallmentItem
                        key={eachInstallment.cantCuotas}
                        installment={eachInstallment}
                        isSelected={selected === eachInstallment.cantCuotas}
                        onInstallmentClick={handleInstallmentClick}
                    />
                )))}
            </div>
        </>
    );

}
